// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1-zH4","inputWrap":"Table_inputWrap__2caa4","col":"Table_col__3GPXj","bmiTooltip":"Table_bmiTooltip__39c7a"};